(function(){
'use strict';
function initStickyHeader(){
  var h=document.querySelector('.site-header');
  if(!h)return;
  window.addEventListener('scroll',function(){h.classList.toggle('scrolled',window.scrollY>40);},{passive:true});
}
function initMobileNav(){
  var t=document.querySelector('.mobile-toggle'),m=document.querySelector('.mobile-menu'),c=document.querySelector('.mobile-menu-close');
  if(!t||!m)return;
  t.addEventListener('click',function(){m.classList.add('active');document.body.style.overflow='hidden';});
  if(c)c.addEventListener('click',function(){m.classList.remove('active');document.body.style.overflow='';});
  m.querySelectorAll('a').forEach(function(a){a.addEventListener('click',function(){m.classList.remove('active');document.body.style.overflow='';});});
}
function initSearch(){
  var btn=document.querySelector('.search-toggle'),overlay=document.querySelector('.search-overlay');
  if(!btn||!overlay)return;
  var input=overlay.querySelector('.search-main-input');
  var closeBtn=overlay.querySelector('.search-close-btn');
  var suggestions=document.getElementById('searchSuggestions');
  var featured=document.getElementById('searchFeatured');
  var resultsEl=document.getElementById('searchResults');
  function openSearch(){overlay.classList.add('active');if(input){input.value='';input.focus();}showDefault();}
  function closeSearch(){overlay.classList.remove('active');}
  function showDefault(){if(suggestions)suggestions.style.display='';if(featured)featured.style.display='';if(resultsEl)resultsEl.style.display='none';}
  function showResults(){if(suggestions)suggestions.style.display='none';if(featured)featured.style.display='none';if(resultsEl)resultsEl.style.display='';}
  btn.addEventListener('click',function(e){e.preventDefault();openSearch();});
  if(closeBtn)closeBtn.addEventListener('click',closeSearch);
  overlay.addEventListener('click',function(e){if(e.target===overlay)closeSearch();});
  document.addEventListener('keydown',function(e){if(e.key==='Escape')closeSearch();});
  document.querySelectorAll('.search-suggestion-item').forEach(function(item){
    item.addEventListener('click',function(){var q=item.dataset.query||item.textContent.trim();if(input){input.value=q;input.form.submit();}});
  });
  if(input&&resultsEl){
    var debounce;
    input.addEventListener('input',function(){
      clearTimeout(debounce);
      var q=input.value.trim();
      if(q.length<2){resultsEl.innerHTML='';showDefault();return;}
      showResults();
      debounce=setTimeout(function(){
        fetch('/search/suggest.json?q='+encodeURIComponent(q)+'&resources[type]=product&resources[limit]=6')
        .then(function(r){return r.json();})
        .then(function(data){
          var products=data.resources&&data.resources.results&&data.resources.results.products||[];
          if(!products.length){resultsEl.innerHTML='<p class="search-no-results">Ingen resultater for "'+q+'"</p>';return;}
          resultsEl.innerHTML='<div class="search-suggestions-label">Resultater</div>'+products.map(function(p){
            var img=p.image?('<img src="'+p.image+'" width="56" height="56" class="search-result-img">'):'<div class="search-result-img-placeholder"></div>';
            return '<a href="'+p.url+'" class="search-result-item">'+img+'<div class="search-result-info"><div class="search-result-title">'+p.title+'</div><div class="search-result-price">'+p.price+'</div></div></a>';
          }).join('');
        }).catch(function(){});
      },250);
    });
  }
}
function initPopup(){
  var popup=document.getElementById('newsletterPopup');
  if(!popup||sessionStorage.getItem('nc_popup_closed'))return;
  setTimeout(function(){popup.classList.add('active');},8000);
  var close=popup.querySelector('.popup-close');
  if(close)close.addEventListener('click',function(){popup.classList.remove('active');sessionStorage.setItem('nc_popup_closed','1');});
  popup.addEventListener('click',function(e){if(e.target===popup){popup.classList.remove('active');sessionStorage.setItem('nc_popup_closed','1');}});
}
function initProductGallery(){
  // Gallery carousel is now handled inline in the product section
  var lightbox=document.getElementById('productLightbox');
  if(!lightbox)return;
  var gallery=document.getElementById('productGallery');
  if(!gallery)return;
  var lbImg=lightbox.querySelector('img'),lbCounter=lightbox.querySelector('.lightbox-counter');
  var images=[];
  gallery.querySelectorAll('.product-gallery-slide img').forEach(function(img){images.push(img.src.replace(/width=\d+/,'width=1800'));});
  var idx=0;
  function show(i){idx=(i+images.length)%images.length;lbImg.src=images[idx];if(lbCounter)lbCounter.textContent=(idx+1)+' / '+images.length;}
  function open(i){show(i);lightbox.classList.add('active');document.body.style.overflow='hidden';}
  function close(){lightbox.classList.remove('active');document.body.style.overflow='';}
  gallery.querySelectorAll('.product-gallery-slide img').forEach(function(img,i){img.addEventListener('dblclick',function(){open(i);});});
  lightbox.querySelector('.lightbox-close').addEventListener('click',close);
  lightbox.querySelector('.lightbox-prev').addEventListener('click',function(e){e.stopPropagation();show(idx-1);});
  lightbox.querySelector('.lightbox-next').addEventListener('click',function(e){e.stopPropagation();show(idx+1);});
  lightbox.addEventListener('click',function(e){if(e.target===lightbox)close();});
  document.addEventListener('keydown',function(e){if(!lightbox.classList.contains('active'))return;if(e.key==='Escape')close();if(e.key==='ArrowLeft')show(idx-1);if(e.key==='ArrowRight')show(idx+1);});
}
function initQuantity(){
  document.querySelectorAll('.qty-wrap').forEach(function(w){
    var input=w.querySelector('.qty-input');
    w.querySelectorAll('.qty-btn').forEach(function(btn){
      btn.addEventListener('click',function(){
        var v=parseInt(input.value)||1;
        if(this.textContent.trim()==='+')input.value=v+1;
        else input.value=Math.max(1,v-1);
      });
    });
  });
}
function initWishlistButtons(){
  document.querySelectorAll('[data-wishlist-btn]').forEach(function(btn){
    var id=btn.dataset.wishlistBtn;
    if(window.NC&&NC.isWishlisted(id))btn.classList.add('active');
    btn.addEventListener('click',function(e){e.preventDefault();e.stopPropagation();if(window.NC)NC.toggleWishlist(id,btn.dataset.wishlistHandle||'');});
  });
}
function initCardSwatches(){
  document.querySelectorAll('.product-card-swatch').forEach(function(swatch){
    var card=swatch.closest('.product-card');
    if(!card)return;
    var img=card.querySelector('.product-card-img-primary');
    if(!img)return;
    // Hover: preview
    swatch.addEventListener('mouseenter',function(){
      img.src=swatch.dataset.image;
    });
    // Leave: revert to active
    swatch.addEventListener('mouseleave',function(){
      var active=card.querySelector('.product-card-swatch.active');
      if(active&&active!==swatch) img.src=active.dataset.image;
    });
    // Click: lock selection
    swatch.addEventListener('click',function(e){
      e.preventDefault();e.stopPropagation();
      img.src=swatch.dataset.image;
      card.querySelectorAll('.product-card-swatch').forEach(function(s){s.classList.remove('active');});
      swatch.classList.add('active');
      if(swatch.dataset.variantUrl) card.dataset.productUrl=swatch.dataset.variantUrl;
    });
  });
}
document.addEventListener('DOMContentLoaded',function(){
  initStickyHeader();initMobileNav();initSearch();initPopup();
  initProductGallery();initQuantity();initWishlistButtons();initCardSwatches();
});
})();
